export const  CLOSED_SIDEBAR_WIDTH = 66
export const  MAIN_SIDEBAR_WIDTH = 94
export const  SUB_SIDEBAR_WIDTH = 170

